interface WizardData {
    [key: string]: any;
}

function transformBoolean(value: string) {
    if (value === 'true') return true;
    if (value === 'false') return false;

    return null;
}

function transformFloat(value: string) {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) return parsedValue;

    return null;
}

function transformStringsToTypes(rawValues: WizardData): WizardData {
    const transformedValues = rawValues;
    Object.keys(transformedValues).forEach((key) => {
        let value = transformedValues[key];
        if (typeof value !== 'string') return;
        value = value.toLowerCase();

        const booleanValue = transformBoolean(value);
        if (booleanValue !== null) {
            transformedValues[key] = booleanValue;
            return;
        }

        const floatValue = transformFloat(value);
        if (floatValue) {
            transformedValues[key] = floatValue;
        }
    });

    return transformedValues;
}

export default transformStringsToTypes;

/* testing data
const values = JSON.parse(
    '{"area":11,"region":"jihocesky","buildingPhase":"thinking","buildDate":"BETWEEN_1970_AND_1980","penB":"","penBType":"","measuredHeatLoss":"","buildingVolumeV":"","totalAreaOfBuildingEnvelope":"","averageHeatTransferCoefficient":"","lossByVentilation":"","lossByInfiltration":"","lossSummary":"","floorPlanShape":"L_SHAPE","groundPlanType":"L_SHAPED_1_TO_2","roofType":"COUNTER","floorCount":"3","garageArea":"","basementArea":"","atticArea":1,"bathroomCount":"3","hasRecuperation":"false","hasHeatedAttic":"false","glazing":"HIGH","wallInsulation":"NONE","wallInsulationThickness":"","floorInsulation":"NONE","floorInsulationThickness":"","roofInsulation":"NONE","roofInsulationThickness":"","roomDispositions":"ONE_PLUS_KITCHEN","roomsDistribution":{"floors":{},"rooms":{},"floorsOrder":[]},"areaTotal":100,"buldingPhase":"building"}',
); */
